import { render } from "./TextInputStats.vue?vue&type=template&id=266ea850&scoped=true&ts=true"
import script from "./TextInputStats.vue?vue&type=script&lang=ts"
export * from "./TextInputStats.vue?vue&type=script&lang=ts"

import "./TextInputStats.vue?vue&type=style&index=0&id=266ea850&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-266ea850"]])

export default __exports__